import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsAdonisjsComponent } from './simple-icons-adonisjs.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsAdonisjsComponent ],
    exports:      [ SimpleIconsAdonisjsComponent ],
    bootstrap:    []
})
export class SimpleIconsAdonisjsModule {}
